<template>
  <el-form ref="form" :rules="CommitForm" :model="form" style="width: 100%" size="mini">
    <el-row>
      <el-col :span="6">
        <el-form-item label="编号 :" prop="code">
          <el-input v-model="form.code" style="width:50%" :disabled="true"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="姓名 :" prop="nameCn">
          <el-input v-model="form.nameCn" style="width:50%"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="性别 :" prop="sex">
          <el-select v-model="form.sex" placeholder="请选择" style="width:40%">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="生日 :" prop="birthdayValue" style="width:90%">
          <div class="block">
            <el-date-picker
              v-model="birthdayValue"
              type="date"
              placeholder="选择日期"
              style="width:150px">
            </el-date-picker>
          </div>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item label="有效时间 :" prop="effectiveTime">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker
              v-model="value1"  style="width: 72%"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions2">
            </el-date-picker>
          </div>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="单位名称 :" prop="deptCode">
          <el-input v-model="form.deptCode" style="width:40%" :disabled="true">
            <el-button slot="append" icon="el-icon-search" @click="openTree"></el-button>
          </el-input>
          <template>
            <el-dialog title="单位选择" :visible.sync="dialogFormVisible">
              <el-tree :data="tree" :props="defaultProps" :expand-on-click-node="false" node-key="id"
                       default-expand-all empty-text="暂无数据" ref="changeparent"
                       highlight-current @node-click="handleNodeClick">
              </el-tree>
              <div slot="footer" class="dialog-footer">
              <el-button type="primary" size="mini" @click="comfirm">确 定</el-button>
              <el-button size="mini" @click="dialogFormVisible = false">取 消</el-button>
              </div>
            </el-dialog>
          </template>
        </el-form-item>
      </el-col>
      <el-col :span="4">
        <el-form-item label="类型名称 :" prop="typeName">
          <el-input v-model="form.typeName" style="width:55%"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="6">
        <el-form-item label="手机 :" prop="mobile">
          <el-input v-model="form.mobile" style="width:48%"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="电话 :" prop="telephone">
          <el-input v-model="form.telephone" style="width:53%"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="email :" prop="email">
          <el-input v-model="form.email" style="width:55%"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="省份名称 :" prop="provinceName">
          <el-input v-model="form.provinceName" style="width:34%"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="6">
        <el-form-item label="城市名称 :" prop="cityName">
          <el-input v-model="form.cityName" style="width:36%"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="区名称 :" prop="areaName">
          <el-input v-model="form.areaName" style="width:46%"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="状态 :" prop="status">
          <el-switch
            v-model="statusValue"
            active-color="#13ce66"
            inactive-color="#ff6969">
          </el-switch>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item label="详细地址 :" prop="address">
          <el-input v-model="form.address" type="textarea" :rows="2" style="width: 73%"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="备注 :" prop="remark">
          <el-input v-model="form.remark" type="textarea" :rows="2" style="width: 73%"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
      <el-row>
        <el-button class="btn" size="mini" @click="cancel">取 消</el-button>
        <el-button class="btn" size="mini" type="primary" @click="submit(form)">确 定</el-button>
    </el-row>
  </el-form>
</template>
<style>
  .header {
    background-color: #e6e6e6;
  }
  .el-dialog__header {
    /* background-color: #F2F6FC; */
    border-radius: 30px 30px 0 0
  }
  .el-dialog {
    border-radius: 30px 30px 30px 30px;
  }
  .btn {
    float: right;
  }
  .btnGroup {
    margin-top: 10%;
  }

  .el-table th.gutter {
    display: table-cell !important;
  }
</style>
<script>
import Cookies from 'js-cookie'
import moment from 'moment'

export default {
  data () {
    return {
      form: {
        birthdayValue: '',
        provinceCode: '',
        cityCode: '',
        areaCode: ''
      },
      tree: [],
      statusValue: true,
      options: [{
        value: '1',
        label: '男'
      }, {
        value: '0',
        label: '女'
      }],
      value: '',
      nodeData: {
        id: '',
        label: ''
      },
      defaultProps: {
        children: 'children',
        label: 'label',
        id: 'code'
      },
      dialogFormVisible: false,
      pickerOptions2: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 26 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 26 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 26 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      value1: [],
      birthdayValue: '',
      radio: '',
      CommitForm: {
        nameCn: [{required: true, trigger: 'blur', message: '用户名称不能为空'}],
        birthdayValue: [{required: true, trigger: 'change', message: '生日日期不能为空'}],
        provinceCode: [{required: true, trigger: 'blur', message: '省份不能为空'}],
        cityCode: [{required: true, trigger: 'blur', message: '城市不能为空'}],
        areaCode: [{required: true, trigger: 'blur', message: '地区不能为空'}]
      }
    }
  },
  methods: {
    dateFormat (row, column) {
      var date = row[column.property]
      if (date === undefined) {
        return ''
      }
      return moment(date).format('YYYY-MM-DD')
    },
    submit (form) {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.form = form
          if (this.statusValue) {
            this.form.status = 50
          } else {
            this.form.status = 30
          }
          this.form.sex = this.radio
          this.form.birthday = moment(this.birthdayValue).format('YYYY-MM-DD')
          this.form.beginDay = moment(this.value1[0]).format('YYYY-MM-DD')
          this.form.endDay = moment(this.value1[1]).format('YYYY-MM-DD')
          let param = {
            data: this.form
          }
          this.$axios({
            method: 'post',
            url: this.global.BASE_ACL + '/user/updateUserInfo',
            data: JSON.stringify(param),
            headers: {
              certificate: Cookies.get(`token_${window.location.port}`),
              'Content-Type': 'application/json'
            }
          }).then((response) => {
            if (response.data.status === 'Y') {
              this.$message({
                showClose: true,
                message: response.data.message,
                type: 'success'
              })
            } else {
              this.$message({
                showClose: true,
                message: response.data.message,
                type: 'error'
              })
            }
            this.$router.push({path: '/dragTabe'})
            let tabItem = this.$store.getters.rightNav
            this.$store.dispatch('removeTab', {tabItem, fullPath: this.$route.fullPath, router: this.$router})
          }).catch((error) => {
            console.log(error) // 请求失败返回的数据
          })
        }
      })
    },
    cancel () {
      this.$router.push({path: '/dragTabe'})
      let tabItem = this.$store.getters.rightNav
      this.$store.dispatch('removeTab', {tabItem, fullPath: this.$route.fullPath, router: this.$router})
    },
    handleNodeClick (data) {
      this.nodeData.id = data.code
      this.nodeData.label = data.label
    },
    comfirm () {
      this.form.deptCode = this.nodeData.label
      this.dialogFormVisible = false
    },
    openTree () {
      this.dialogFormVisible = true
    }
  },
  created () {
    let row = this.$route.params.row
    this.form = row
    this.value1.push(row.beginDay)
    this.value1.push(row.endDay)
    this.birthdayValue = row.birthday
    if (row.status === 50) {
      this.statusValue = true
    } else {
      this.statusValue = false
    }
    this.radio = row.sex
    this.$axios({
      method: 'post',
      url: this.global.BASE_INFO + '/org/findAllOrgs',
      headers: {
        certificate: Cookies.get(`token_${window.location.port}`)
      }
    }).then((response) => {
      this.tree = response.data.data
    }).catch((error) => {
      console.log(error)
    })
  },
  message () {
    const h = this.$createElement
    this.$notify({
      title: '提示',
      message: h('i', {style: 'color: teal'}, ''),
      duration: 6000
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/user/update.vue